import { c as _c } from "react/compiler-runtime";
import type { MergeabilityStatus } from '@/lib/hooks/mergeability-status/get-mergeability-status.server';
import { CircleCheck, CircleDashed, CircleX } from 'lucide-react';
import { isBlockedByBranchRules } from '@/lib/hooks/mergeability-status/get-mergeability-status.server';
type HeaderProps = {
  mergeabilityStatus: MergeabilityStatus;
};
const HEADER_STYLE = 'flex items-center gap-2 text-base font-semibold sticky top-0 bg-black w-full z-10 px-4';
const HEADER_ICON_STYLE = 'size-4 -translate-y-px mt-[1px]';
export function Header(t0) {
  const $ = _c(5);
  const {
    mergeabilityStatus
  } = t0;
  if (mergeabilityStatus.canMerge) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className={HEADER_STYLE}><CircleCheck className={HEADER_ICON_STYLE} />Ready to merge</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (mergeabilityStatus.mergeQueue === "queued") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className={HEADER_STYLE}><CircleDashed className={HEADER_ICON_STYLE} />Queued to merge</div>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CircleX className={HEADER_ICON_STYLE} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isBlockedByBranchRules(mergeabilityStatus) ? "Blocked by branch rules" : "Merge conditions not met";
  let t3;
  if ($[3] !== t2) {
    t3 = <div className={HEADER_STYLE}>{t1}{t2}</div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}